(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fochai-article-editorial"]) return;
  try {
    
(function () {
  var context = document.querySelector('[data-fochai-article-editorial-context]');
  var articleRoot = document.querySelector('.article-template__content');

  function slug(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/ł/g, 'l')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '')
      .slice(0, 90) || 'article_link';
  }

  function applyProductTracking() {
    if (!context || !articleRoot || !articleRoot.querySelector('.atp-editorial')) return;

    articleRoot.querySelectorAll('a[data-blog-product-link]').forEach(function (link) {
      var url;

      try {
        url = new URL(link.getAttribute('href'), window.location.origin);
      } catch (error) {
        return;
      }

      if (url.origin !== window.location.origin || !url.pathname.match(/^\/products\//)) return;

      var module = link.closest('[data-sd-engagement-module]');
      var moduleName = module ? module.getAttribute('data-sd-engagement-module') : 'article_product';
      var productHandle = link.dataset.productHandle || url.pathname.split('/')[2] || '';
      var productTitle = link.dataset.productTitle || link.textContent.trim();

      link.dataset.sdBlogTracking = 'true';
      link.dataset.sdBlogSource = 'blog_article_editorial';
      link.dataset.sdBlogArticle = context.dataset.articleTitle || '';
      link.dataset.sdBlogArticleHandle = context.dataset.articleHandle || '';
      link.dataset.sdBlogArticleId = context.dataset.articleId || '';
      link.dataset.sdBlogArticleUrl = context.dataset.articleUrl || '';
      link.dataset.sdBlogArticleModule = moduleName;
      link.dataset.sdBlogArticleLink = slug(link.textContent);
      link.dataset.sdBlogProductHandle = productHandle;
      link.dataset.sdBlogProductTitle = productTitle;
      link.dataset.sdBlogUtmSource = 'blog';
      link.dataset.sdBlogUtmMedium = 'article_editorial';
      link.dataset.sdBlogUtmCampaign = context.dataset.articleHandle || '';
      link.dataset.sdBlogUtmContent = moduleName + '_' + slug(link.textContent);
      link.setAttribute('href', url.pathname + url.search + url.hash);
    });
  }

  applyProductTracking();

  var root = document.querySelector('[data-atp-stories]');
  if (!root) return;

  var track = root.querySelector('[data-atp-story-track]');
  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-atp-story]'));
  var progress = Array.prototype.slice.call(root.querySelectorAll('[data-atp-story-progress]'));
  var previous = root.querySelector('[data-atp-story-prev]');
  var next = root.querySelector('[data-atp-story-next]');
  var status = root.querySelector('[data-atp-story-status]');
  var activeIndex = 0;
  var ticking = false;

  if (!track || slides.length === 0) return;

  function slideLeft(index) {
    return slides[index].offsetLeft - track.offsetLeft;
  }

  function findClosestSlide() {
    var closestIndex = 0;
    var closestDistance = Infinity;
    slides.forEach(function (slide, index) {
      var distance = Math.abs(slideLeft(index) - track.scrollLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });
    return closestIndex;
  }

  function update(index) {
    activeIndex = Math.max(0, Math.min(index, slides.length - 1));
    progress.forEach(function (segment, segmentIndex) {
      segment.classList.toggle('is-active', segmentIndex <= activeIndex);
    });
    if (previous) previous.disabled = activeIndex === 0;
    if (next) next.disabled = activeIndex === slides.length - 1;
    if (status) status.textContent = 'Slajd ' + (activeIndex + 1) + ' z ' + slides.length;
  }

  function goTo(index) {
    var targetIndex = Math.max(0, Math.min(index, slides.length - 1));
    track.scrollTo({
      left: slideLeft(targetIndex),
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
    update(targetIndex);
  }

  track.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      update(findClosestSlide());
      ticking = false;
    });
  }, { passive: true });

  track.addEventListener('keydown', function (event) {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      goTo(activeIndex - 1);
    }
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      goTo(activeIndex + 1);
    }
  });

  if (previous) previous.addEventListener('click', function () { goTo(activeIndex - 1); });
  if (next) next.addEventListener('click', function () { goTo(activeIndex + 1); });

  update(0);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-expert-opinion"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initExpertOpinion() {
    document.querySelectorAll('[data-sd-expert-opinion]').forEach(function (root) {
      if (root.dataset.sdExpertInit) return;
      root.dataset.sdExpertInit = '1';

      var track = root.querySelector('[data-sd-expert-track]');
      var slides = Array.from(root.querySelectorAll('[data-sd-expert-slide]'));
      var dots = Array.from(root.querySelectorAll('[data-sd-expert-dot]'));
      var prev = root.querySelector('[data-sd-expert-prev]');
      var next = root.querySelector('[data-sd-expert-next]');
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!track || slides.length < 2) return;

      function activeIndex() {
        var width = track.getBoundingClientRect().width || 1;
        return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / width)));
      }

      function setActiveDot() {
        var index = activeIndex();
        dots.forEach(function (dot, dotIndex) {
          var active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          if (active) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      function goTo(index) {
        var slide = slides[Math.max(0, Math.min(slides.length - 1, index))];
        if (!slide) return;
        track.scrollTo({ left: slide.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { goTo(activeIndex() - 1); });
      if (next) next.addEventListener('click', function () { goTo(activeIndex() + 1); });
      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () { goTo(index); });
      });

      var frame = 0;
      track.addEventListener('scroll', function () {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(setActiveDot);
      }, { passive: true });
      setActiveDot();
    });
  }

  initExpertOpinion();
  document.addEventListener('shopify:section:load', initExpertOpinion);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-featured-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  var trustmateCache = {};

  function verifiedReviewsLabel(count) {
    var n = parseInt(count, 10) || 0;
    var mod10 = n % 10;
    var mod100 = n % 100;
    if (n === 1) return 'opinia';
    if (mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14)) return 'opinie';
    return 'opinii';
  }

  function parseTrustmateRatingHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var label = doc.querySelector('.tm-grade-label__text');
    var starImg = doc.querySelector('.tm-grade-label__stars img');
    var score = label ? label.textContent.replace(/\s+/g, ' ').trim() : '';
    var count = label ? label.getAttribute('data-reviews') : '';
    var structuredData = doc.querySelectorAll('script[type="application/ld+json"]');

    Array.prototype.some.call(structuredData, function (script) {
      try {
        var data = JSON.parse(script.textContent || '{}');
        var rating = data && data.aggregateRating;
        if (!rating) return false;
        if (!score && rating.ratingValue) score = Number(rating.ratingValue).toFixed(1);
        if (!count && rating.reviewCount) count = String(rating.reviewCount);
        return Boolean(score || count);
      } catch (_err) {
        return false;
      }
    });

    if (!score && !count) return null;
    return {
      score: score,
      count: count,
      starSrc: starImg ? starImg.getAttribute('src') : ''
    };
  }

  function fetchTrustmateRating(token, productId) {
    var cacheKey = token + ':' + productId;
    if (!trustmateCache[cacheKey]) {
      var url = 'https://trustmate.io/widget/api/' +
        encodeURIComponent(token) +
        '/html?product=' +
        encodeURIComponent(productId) +
        '&disable-extra=1';
      trustmateCache[cacheKey] = fetch(url, { credentials: 'omit' })
        .then(function (response) {
          if (!response.ok) throw new Error('Reviews response ' + response.status);
          return response.text();
        })
        .then(parseTrustmateRatingHtml);
    }
    return trustmateCache[cacheKey];
  }

  function renderProductTrustmateRating(root, rating) {
    if (!rating) return;
    var scoreEl = root.querySelector('[data-sd-product-trustmate-score]');
    var countEl = root.querySelector('[data-sd-product-trustmate-count]');
    var starsEl = root.querySelector('[data-sd-product-trustmate-stars]');
    var reviewCount = parseInt(rating.count, 10) || 0;

    if (scoreEl && rating.score) scoreEl.textContent = rating.score + '/5';
    if (countEl && reviewCount > 0) {
      countEl.hidden = false;
      countEl.textContent = '(' + reviewCount + ' ' + verifiedReviewsLabel(reviewCount) + ')';
    }
    if (starsEl && rating.starSrc) {
      starsEl.innerHTML = '';
      var img = document.createElement('img');
      img.src = rating.starSrc;
      img.alt = '';
      img.loading = 'lazy';
      img.width = 103;
      img.height = 20;
      starsEl.appendChild(img);
    }

    root.classList.add('is-trustmate-loaded');
  }

  function initProductTrustmateRatings() {
    document.querySelectorAll('[data-sd-product-trustmate-rating]').forEach(function (root) {
      if (root.dataset.sdProductTrustmateLoaded) return;
      var token = root.dataset.trustmateToken;
      var productId = root.dataset.trustmateProductId;
      if (!token || !productId) return;

      root.dataset.sdProductTrustmateLoaded = '1';
      fetchTrustmateRating(token, productId)
        .then(function (rating) {
          renderProductTrustmateRating(root, rating);
        })
        .catch(function () {
          root.dataset.sdProductTrustmateLoaded = '';
        });
    });
  }

  function setReviewsDuplicateHidden(group) {
    group.setAttribute('aria-hidden', 'true');
    group.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (node) {
      node.setAttribute('tabindex', '-1');
    });
    group.querySelectorAll('[id], [data-shopify-editor-block], [data-shopify-editor-setting]').forEach(function (node) {
      node.removeAttribute('id');
      Array.prototype.slice.call(node.attributes).forEach(function (attribute) {
        if (attribute.name.indexOf('data-shopify') === 0) {
          node.removeAttribute(attribute.name);
        }
      });
    });
  }

  function initReviewsMarquee() {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    document.querySelectorAll('[data-sd-reviews-slider]').forEach(function (root) {
      if (root.dataset.sdReviewsMarqueeInit) return;

      var viewport = root.querySelector('.sd-featured-products__reviews-marquee');
      var track = root.querySelector('[data-sd-reviews-track]');
      var initialGroups = track ? track.querySelectorAll('.sd-featured-products__reviews-group') : [];
      if (!viewport || !track || initialGroups.length < 2) return;

      root.dataset.sdReviewsMarqueeInit = '1';

      var beforeGroup = initialGroups[0].cloneNode(true);
      setReviewsDuplicateHidden(beforeGroup);
      track.insertBefore(beforeGroup, initialGroups[0]);

      var groups = track.querySelectorAll('.sd-featured-products__reviews-group');
      var loopWidth = 0;
      var frame = 0;
      var lastTime = 0;
      var pausedUntil = 0;
      var isPointerDown = false;
      var isHoverPaused = false;

      function measure() {
        groups = track.querySelectorAll('.sd-featured-products__reviews-group');
        if (groups.length < 3) return;
        loopWidth = groups[1].offsetLeft - groups[0].offsetLeft;
        if (!loopWidth) loopWidth = groups[2].offsetLeft - groups[1].offsetLeft;
        if (!loopWidth) loopWidth = track.scrollWidth / groups.length;
        if (loopWidth > 0 && viewport.scrollLeft < 1) {
          viewport.scrollLeft = loopWidth;
        }
        normalize();
      }

      function normalize() {
        if (!loopWidth) return;
        var lowerEdge = loopWidth * 0.5;
        var upperEdge = loopWidth * 1.5;

        if (viewport.scrollLeft < lowerEdge) {
          viewport.scrollLeft += loopWidth;
        } else if (viewport.scrollLeft >= upperEdge) {
          viewport.scrollLeft -= loopWidth;
        }
      }

      function cardStep() {
        var card = track.querySelector('.sd-featured-products__review');
        var group = track.querySelector('.sd-featured-products__reviews-group');
        if (!card || !group) return 0;
        var gap = parseFloat(window.getComputedStyle(group).columnGap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function pause(duration) {
        pausedUntil = performance.now() + duration;
      }

      function tick(time) {
        if (!root.isConnected) {
          window.cancelAnimationFrame(frame);
          return;
        }

        if (!lastTime) lastTime = time;
        var elapsed = time - lastTime;
        lastTime = time;

        if (!reduceMotion.matches && !isPointerDown && !isHoverPaused && time > pausedUntil) {
          var step = cardStep();
          if (step > 0) {
            viewport.scrollLeft += (step / 7.5) * (elapsed / 1000);
            normalize();
          }
        }

        frame = window.requestAnimationFrame(tick);
      }

      viewport.addEventListener('pointerdown', function () {
        isPointerDown = true;
        pause(1600);
      }, { passive: true });

      viewport.addEventListener('pointerup', function () {
        isPointerDown = false;
        pause(900);
        normalize();
      }, { passive: true });

      viewport.addEventListener('pointercancel', function () {
        isPointerDown = false;
        pause(900);
        normalize();
      }, { passive: true });

      viewport.addEventListener('touchstart', function () {
        isPointerDown = true;
        pause(1600);
      }, { passive: true });

      viewport.addEventListener('touchend', function () {
        isPointerDown = false;
        pause(900);
        normalize();
      }, { passive: true });

      viewport.addEventListener('wheel', function () {
        pause(1400);
      }, { passive: true });

      viewport.addEventListener('mouseenter', function () {
        isHoverPaused = true;
      });

      viewport.addEventListener('mouseleave', function () {
        isHoverPaused = false;
        lastTime = 0;
      });

      viewport.addEventListener('scroll', normalize, { passive: true });
      window.addEventListener('resize', measure);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(measure).catch(function () {});
      }

      measure();
      frame = window.requestAnimationFrame(tick);

      document.addEventListener('shopify:section:unload', function (event) {
        if (event.target === root && frame) {
          window.cancelAnimationFrame(frame);
        }
      });
    });
  }

  initProductTrustmateRatings();
  initReviewsMarquee();
  document.addEventListener('shopify:section:load', initProductTrustmateRatings);
  document.addEventListener('shopify:section:load', initReviewsMarquee);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-knowledge-hub"] && !Shopify.designMode) return;
  try {
    
(() => {
  const roots = document.querySelectorAll('[data-sd-knowledge-hub]');

  roots.forEach((root) => {
    if (root.dataset.sdKnowledgeInit === 'true') return;

    const viewport = root.querySelector('[data-sd-knowledge-viewport]');
    const track = root.querySelector('[data-sd-knowledge-track]');
    const cards = track ? Array.from(track.children) : [];
    const prevButtons = Array.from(root.querySelectorAll('[data-sd-knowledge-prev]'));
    const nextButtons = Array.from(root.querySelectorAll('[data-sd-knowledge-next]'));
    const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!viewport || !track || !cards.length || !prevButtons.length || !nextButtons.length) return;

    root.dataset.sdKnowledgeInit = 'true';

    const numberFromStyle = (value) => {
      const parsed = parseFloat(value || '0');
      return Number.isFinite(parsed) ? parsed : 0;
    };

    const getStep = () => {
      const styles = window.getComputedStyle(track);
      const gap = numberFromStyle(styles.columnGap || styles.gap);
      return cards[0].getBoundingClientRect().width + gap;
    };

    const getMaxScroll = () => Math.max(viewport.scrollWidth - viewport.clientWidth, 0);

    const getCurrentIndex = () => {
      const step = getStep();
      if (!step) return 0;
      return Math.max(0, Math.min(Math.round(viewport.scrollLeft / step), cards.length - 1));
    };

    const scrollBehavior = () => (reduceMotionQuery.matches ? 'auto' : 'smooth');

    const scrollToIndex = (index) => {
      const step = getStep();
      if (!step) return;
      const targetIndex = Math.max(0, Math.min(index, cards.length - 1));
      viewport.scrollTo({
        left: Math.min(step * targetIndex, getMaxScroll()),
        behavior: scrollBehavior()
      });
    };

    const scrollByCard = (direction) => {
      const step = getStep();
      if (!step) return;

      const maxScroll = getMaxScroll();
      const currentIndex = getCurrentIndex();
      if (direction > 0 && (currentIndex >= cards.length - 1 || viewport.scrollLeft >= maxScroll - 8)) {
        scrollToIndex(0);
        return;
      }

      if (direction < 0 && (currentIndex <= 0 || viewport.scrollLeft < 8)) {
        scrollToIndex(cards.length - 1);
        return;
      }

      viewport.scrollBy({
        left: step * direction,
        behavior: scrollBehavior()
      });
    };

    const prevHandler = () => scrollByCard(-1);
    const nextHandler = () => scrollByCard(1);

    prevButtons.forEach((button) => {
      button.addEventListener('click', prevHandler);
    });
    nextButtons.forEach((button) => {
      button.addEventListener('click', nextHandler);
    });

    const unloadHandler = (event) => {
      if (event.target !== root) return;
      prevButtons.forEach((button) => {
        button.removeEventListener('click', prevHandler);
      });
      nextButtons.forEach((button) => {
        button.removeEventListener('click', nextHandler);
      });
      document.removeEventListener('shopify:section:unload', unloadHandler);
    };

    document.addEventListener('shopify:section:unload', unloadHandler);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-products-carousel"] && !Shopify.designMode) return;
  try {
    
(() => {
  const trustmateCache = {};

  const reviewsLabel = (count) => {
    const n = parseInt(count, 10) || 0;
    const mod10 = n % 10;
    const mod100 = n % 100;
    if (n === 1) return 'opinia';
    if (mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14)) return 'opinie';
    return 'opinii';
  };

  const parseTrustmateRating = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const label = doc.querySelector('.tm-grade-label__text');
    const starImg = doc.querySelector('.tm-grade-label__stars img');
    let score = label ? label.textContent.replace(/\s+/g, ' ').trim() : '';
    let count = label ? label.getAttribute('data-reviews') : '';
    const structuredData = doc.querySelectorAll('script[type="application/ld+json"]');

    Array.prototype.some.call(structuredData, (script) => {
      try {
        const data = JSON.parse(script.textContent || '{}');
        const rating = data && data.aggregateRating;
        if (!rating) return false;
        if (!score && rating.ratingValue) score = Number(rating.ratingValue).toFixed(1);
        if (!count && rating.reviewCount) count = String(rating.reviewCount);
        return Boolean(score || count);
      } catch (_error) {
        return false;
      }
    });

    if (!score && !count) return null;
    return {
      score,
      count,
      starSrc: starImg ? starImg.getAttribute('src') : ''
    };
  };

  const fetchTrustmateRating = (token, productId) => {
    const cacheKey = token + ':' + productId;
    if (!trustmateCache[cacheKey]) {
      const url = 'https://trustmate.io/widget/api/' +
        encodeURIComponent(token) +
        '/html?product=' +
        encodeURIComponent(productId) +
        '&disable-extra=1';
      trustmateCache[cacheKey] = fetch(url, { credentials: 'omit' })
        .then((response) => {
          if (!response.ok) throw new Error('Reviews response ' + response.status);
          return response.text();
        })
        .then(parseTrustmateRating);
    }
    return trustmateCache[cacheKey];
  };

  const renderTrustmateRating = (root, rating) => {
    if (!rating) return;
    const scoreEl = root.querySelector('[data-sd-products-trustmate-score]');
    const countEl = root.querySelector('[data-sd-products-trustmate-count]');
    const starsEl = root.querySelector('[data-sd-products-trustmate-stars]');
    const count = parseInt(rating.count, 10) || 0;

    if (scoreEl && rating.score) scoreEl.textContent = rating.score + '/5';
    if (countEl && count > 0) {
      countEl.textContent = '(' + count + ' ' + reviewsLabel(count) + ')';
      countEl.hidden = false;
    }
    if (starsEl && rating.starSrc) {
      starsEl.innerHTML = '';
      const img = document.createElement('img');
      img.src = rating.starSrc;
      img.alt = '';
      img.loading = 'lazy';
      img.width = 103;
      img.height = 20;
      starsEl.appendChild(img);
    }
    root.classList.add('is-trustmate-loaded');
  };

  const initTrustmateRatings = (context = document) => {
    context.querySelectorAll('[data-sd-products-trustmate-rating]').forEach((root) => {
      if (root.dataset.sdProductsTrustmateLoaded) return;
      const token = root.dataset.trustmateToken;
      const productId = root.dataset.trustmateProductId;
      if (!token || !productId) return;
      root.dataset.sdProductsTrustmateLoaded = '1';
      fetchTrustmateRating(token, productId)
        .then((rating) => {
          renderTrustmateRating(root, rating);
        })
        .catch(() => {
          root.dataset.sdProductsTrustmateLoaded = '';
        });
    });
  };

  initTrustmateRatings();
  document.addEventListener('shopify:section:load', (event) => {
    initTrustmateRatings(event.target);
  });

  const roots = document.querySelectorAll('[data-sd-products-carousel]');

  roots.forEach((root) => {
    if (root.dataset.sdProductsCarouselReady === 'true') return;

    const viewport = root.querySelector('[data-sd-products-viewport]');
    const track = root.querySelector('[data-sd-products-track]');
    const cards = track ? Array.from(track.children) : [];
    const prevButtons = Array.from(root.querySelectorAll('[data-sd-products-prev]'));
    const nextButtons = Array.from(root.querySelectorAll('[data-sd-products-next]'));
    const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!viewport || !track || !cards.length || !prevButtons.length || !nextButtons.length) return;

    root.dataset.sdProductsCarouselReady = 'true';

    const numberFromStyle = (value) => {
      const parsed = parseFloat(value || '0');
      return Number.isFinite(parsed) ? parsed : 0;
    };

    const getStep = () => {
      const styles = window.getComputedStyle(track);
      const gap = numberFromStyle(styles.columnGap || styles.gap);
      return cards[0].getBoundingClientRect().width + gap;
    };

    const getMaxScroll = () => Math.max(viewport.scrollWidth - viewport.clientWidth, 0);

    const update = () => {
      const maxScroll = getMaxScroll();

      prevButtons.forEach((button) => {
        button.disabled = viewport.scrollLeft < 8;
      });
      nextButtons.forEach((button) => {
        button.disabled = viewport.scrollLeft >= maxScroll - 8;
      });
    };

    const scrollByCard = (direction) => {
      const step = getStep();
      if (!step) return;

      viewport.scrollBy({
        left: step * direction,
        behavior: reduceMotionQuery.matches ? 'auto' : 'smooth'
      });
    };

    let frame = null;
    const requestUpdate = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = null;
        update();
      });
    };

    const prevHandler = () => scrollByCard(-1);
    const nextHandler = () => scrollByCard(1);

    prevButtons.forEach((button) => {
      button.addEventListener('click', prevHandler);
    });
    nextButtons.forEach((button) => {
      button.addEventListener('click', nextHandler);
    });
    viewport.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });

    let autoscrollTimer = null;
    let resumeTimer = null;
    const shouldAutoscroll = root.dataset.autoscroll === 'true' && !reduceMotionQuery.matches;
    const autoscrollSeconds = Math.max(parseFloat(root.dataset.autoscrollSeconds || '4'), 1);

    const stopAutoscroll = () => {
      if (autoscrollTimer) {
        window.clearInterval(autoscrollTimer);
        autoscrollTimer = null;
      }
    };

    const startAutoscroll = () => {
      if (!shouldAutoscroll || autoscrollTimer) return;
      autoscrollTimer = window.setInterval(() => {
        const maxScroll = getMaxScroll();
        if (viewport.scrollLeft >= maxScroll - 8) {
          viewport.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          scrollByCard(1);
        }
      }, autoscrollSeconds * 1000);
    };

    const pauseAutoscroll = (delay = 1200) => {
      stopAutoscroll();
      window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(startAutoscroll, delay);
    };

    viewport.addEventListener('pointerdown', () => pauseAutoscroll(1800), { passive: true });
    viewport.addEventListener('touchstart', () => pauseAutoscroll(1800), { passive: true });
    viewport.addEventListener('wheel', () => pauseAutoscroll(1400), { passive: true });

    update();
    startAutoscroll();

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target !== root) return;
      prevButtons.forEach((button) => {
        button.removeEventListener('click', prevHandler);
      });
      nextButtons.forEach((button) => {
        button.removeEventListener('click', nextHandler);
      });
      window.removeEventListener('resize', requestUpdate);
      window.clearTimeout(resumeTimer);
      stopAutoscroll();
      if (frame) {
        window.cancelAnimationFrame(frame);
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-research-results"] && !Shopify.designMode) return;
  try {
    
(() => {
  const roots = document.querySelectorAll('[data-sd-research-results]');

  roots.forEach((root) => {
    if (root.dataset.sdResearchReady === 'true') return;

    const track = root.querySelector('[data-sd-research-track]');
    const cards = track ? Array.from(track.children) : [];
    const current = root.querySelector('[data-sd-research-current]');
    const progress = root.querySelector('[data-sd-research-progress]');
    const prevEls = Array.from(root.querySelectorAll('[data-sd-research-prev]'));
    const nextEls = Array.from(root.querySelectorAll('[data-sd-research-next]'));

    if (!track || !cards.length || !current || !progress || !prevEls.length || !nextEls.length) return;

    root.dataset.sdResearchReady = 'true';

    const getStep = () => {
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 24;
      return cards[0].getBoundingClientRect().width + gap;
    };

    const update = () => {
      const step = getStep();
      const index = Math.round(track.scrollLeft / step);
      const currentIndex = Math.min(index + 1, cards.length);
      const maxScroll = track.scrollWidth - track.clientWidth;
      const percent = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;

      current.textContent = String(currentIndex).padStart(2, '0');
      progress.style.width = `${18 + percent * 82}%`;
      prevEls.forEach((b) => { b.disabled = track.scrollLeft < 8; });
      nextEls.forEach((b) => { b.disabled = track.scrollLeft >= maxScroll - 8; });
    };

    const scrollByCard = (direction) => {
      track.scrollBy({
        left: getStep() * direction,
        behavior: 'smooth'
      });
    };

    let frame = null;
    const requestUpdate = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = null;
        update();
      });
    };

    const prevHandler = () => scrollByCard(-1);
    const nextHandler = () => scrollByCard(1);

    prevEls.forEach((b) => b.addEventListener('click', prevHandler));
    nextEls.forEach((b) => b.addEventListener('click', nextHandler));
    track.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });

    update();

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target !== root) return;
      prevEls.forEach((b) => b.removeEventListener('click', prevHandler));
      nextEls.forEach((b) => b.removeEventListener('click', nextHandler));
      window.removeEventListener('resize', requestUpdate);
      if (frame) {
        window.cancelAnimationFrame(frame);
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sd-social-media-showcase"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sections = document.querySelectorAll('[data-sd-social-showcase]');

  sections.forEach((root) => {
    const viewport = root.querySelector('[data-sd-social-viewport]');
    const track = root.querySelector('[data-sd-social-track]');
    const prev = root.querySelector('[data-sd-social-prev]');
    const next = root.querySelector('[data-sd-social-next]');
    const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!viewport || !track) return;

    const state = {
      offset: 0,
      loopWidth: 0,
      step: 0,
      speed: 0,
      frame: null,
      tweenFrame: null,
      lastTime: 0
    };

    const numberFromStyle = (value) => {
      const parsed = parseFloat(value || '0');
      return Number.isFinite(parsed) ? parsed : 0;
    };

    const normalizeOffset = (value) => {
      if (!state.loopWidth) return 0;
      let nextOffset = value % state.loopWidth;
      if (nextOffset < 0) {
        nextOffset += state.loopWidth;
      }
      return nextOffset;
    };

    const setOffset = (value) => {
      state.offset = normalizeOffset(value);
      track.style.setProperty('--sd-social-offset', `${-state.offset}px`);
    };

    const measure = () => {
      const group = track.querySelector('[data-sd-social-group]');
      const card = track.querySelector('.sd-social-showcase__card');
      if (!group || !card) return;

      const trackStyles = window.getComputedStyle(track);
      const groupStyles = window.getComputedStyle(group);
      const trackGap = numberFromStyle(trackStyles.columnGap || trackStyles.gap);
      const groupGap = numberFromStyle(groupStyles.columnGap || groupStyles.gap);
      const seconds = Math.max(parseFloat(root.dataset.autoscrollSeconds || '2'), 1);

      state.loopWidth = group.scrollWidth + trackGap;
      state.step = card.getBoundingClientRect().width + groupGap;
      state.speed = state.step / seconds;
      setOffset(state.offset);
    };

    let resumeTimer;
    const pauseBriefly = (delayOrEvent = 900) => {
      const delay = typeof delayOrEvent === 'number' ? delayOrEvent : 900;
      root.dataset.userPaused = 'true';
      window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(() => {
        delete root.dataset.userPaused;
      }, delay);
    };

    const cancelTween = () => {
      if (state.tweenFrame) {
        window.cancelAnimationFrame(state.tweenFrame);
        state.tweenFrame = null;
      }
    };

    const easeOutCubic = (progress) => 1 - Math.pow(1 - progress, 3);

    const moveByCard = (direction) => {
      if (!state.step || !state.loopWidth) return;

      cancelTween();
      pauseBriefly(850);

      const distance = direction * state.step;
      const duration = reduceMotionQuery.matches ? 0 : 320;
      let start = state.offset;

      if (distance < 0 && start + distance < 0) {
        start += state.loopWidth;
      }

      if (!duration) {
        setOffset(start + distance);
        return;
      }

      const startTime = window.performance.now();

      const animate = (time) => {
        const progress = Math.min((time - startTime) / duration, 1);
        setOffset(start + distance * easeOutCubic(progress));

        if (progress < 1) {
          state.tweenFrame = window.requestAnimationFrame(animate);
        } else {
          state.tweenFrame = null;
        }
      };

      state.tweenFrame = window.requestAnimationFrame(animate);
    };

    if (prev) {
      prev.addEventListener('click', () => moveByCard(-1));
    }

    if (next) {
      next.addEventListener('click', () => moveByCard(1));
    }

    viewport.addEventListener('pointerdown', pauseBriefly, { passive: true });
    viewport.addEventListener('touchstart', pauseBriefly, { passive: true });
    viewport.addEventListener('wheel', pauseBriefly, { passive: true });

    const videos = Array.from(root.querySelectorAll('[data-sd-social-video]'));
    const shouldPlayVideos = root.dataset.playVideos === 'true' && !reduceMotionQuery.matches;

    if (videos.length && shouldPlayVideos && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }, { root: null, threshold: 0.45 });

      videos.forEach((video) => observer.observe(video));
    }

    measure();

    const resizeHandler = () => measure();
    window.addEventListener('resize', resizeHandler, { passive: true });

    let resizeObserver;
    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(measure);
      resizeObserver.observe(viewport);
    }

    const shouldAutoScroll = root.dataset.autoscroll === 'true' && !reduceMotionQuery.matches;

    if (!shouldAutoScroll) {
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target !== root) return;
        window.removeEventListener('resize', resizeHandler);
        if (resizeObserver) resizeObserver.disconnect();
      });
      return;
    }

    const tick = (time) => {
      if (!state.lastTime) {
        state.lastTime = time;
      }

      const elapsed = time - state.lastTime;
      state.lastTime = time;

      if (root.dataset.userPaused !== 'true' && !state.tweenFrame && state.speed > 0) {
        setOffset(state.offset + state.speed * (elapsed / 1000));
      }

      state.frame = window.requestAnimationFrame(tick);
    };

    state.frame = window.requestAnimationFrame(tick);

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target !== root) return;
      window.removeEventListener('resize', resizeHandler);
      window.clearTimeout(resumeTimer);
      if (resizeObserver) resizeObserver.disconnect();
      if (state.frame) window.cancelAnimationFrame(state.frame);
      cancelTween();
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
